import React, { useState } from "react";
import logoImage from '../../../assets/Slide8.png';
import { forgotPassword } from '../../../utils/auth.controller';
import styles from './Login.module.css';
import CreateForm from '../../Design/Forms/CreateForm'; // Import CreateForm
import { FormFields } from '../../Design/Forms/FormJson'; // Import FormFields
import BackgroundImage from '../../../assets/Background.png';


const ForgotPassword = () => {
  const [formData, setFormData] = useState({
    email: ''
  });
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false); // Loading state for forgot password process

  // Forgot Password handler
  const handleForgotPassword = async (e) => {
    e.preventDefault(); // Prevent form from submitting by default
    if (!formData.email) {
      setErrorMessage("Please provide an email address.");
      return;
    }
    setIsLoading(true); // Set loading to true when starting the request

    try {
      await forgotPassword(formData.email); // Call the forgotPassword function
      setErrorMessage(""); // Clear any previous error messages
      alert("If the email is registered, we have sent a reset link to it.");
    } catch (error) {
      setErrorMessage("An error occurred. Please try again later.");
    } finally {
      setIsLoading(false); // Stop the loading when done
    }
  };

  return (
    <div className={styles.loginPage} style={{ backgroundImage: `url(${BackgroundImage})` }}>
       <div
        className={styles.loginImage}
        style={{ backgroundImage: `url(${logoImage})` }} // Using the imported image
      ></div> 

      {/* Right Side Form */}
      <div className={styles.loginFormContainer}>
        <div className={styles.loginForm}>
          <h2>Forgot Password</h2>

          {/* Use CreateForm to render forgotPasswordFields */}
          <CreateForm
            formData={formData}
            setFormData={setFormData}
            onSubmit={handleForgotPassword}
            text={isLoading ? "Sending..." : "Send Reset Link"}
            fields={FormFields.forgotPasswordFields} // Pass forgotPasswordFields from FormFields
          />

          {/* Submit Button (same as the button inside CreateForm, no need to duplicate it) */}
          {/* {errorMessage && <p className="error-message">{errorMessage}</p>} */}
          {errorMessage && <p className={styles.errorMessage}>{errorMessage}</p>}

          <div className={styles.forgotPasswordContainer}>
            <p>Remembered your password? <a href="/login">Login here</a></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
